import React, { FC, ReactElement } from 'react'
import styles from './CollectionSocials.module.css'
import type { CollectionSocials as CollectionSocialsType } from '@/utils/types/collections'
import ProfileSocialLink from '@/components/profile-social-link'
import TwitterIcon from '@/icons/twitter'
import DiscordIcon from '@/icons/discord'
import LinkIcon from '@/icons/link'
import classnames from 'classnames'
import { Images } from 'lucide-react'

const CollectionSocials: FC<{
	classsName?: string
	galleryInscriptionId?: string | null
	iconClassName?: string
	socials: CollectionSocialsType
}> = (props): ReactElement => {
	const { galleryInscriptionId, socials } = props
	const ordGalleryUrl = galleryInscriptionId
		? `https://ordinals.com/gallery/${galleryInscriptionId}`
		: ''

	return (
		<div className={classnames({ [(props.classsName as any)]: !!props.classsName }, styles.root)}>
			{ordGalleryUrl && (
				<ProfileSocialLink
					ariaLabel="View ORD Gallery"
					icon={Images}
					iconClassName={classnames(styles.linkIcon, props.iconClassName)}
					href={ordGalleryUrl}
					title="View ORD Gallery"
				/>
			)}
			{socials?.website && (
				<ProfileSocialLink
					icon={LinkIcon}
					iconClassName={classnames(styles.linkIcon, props.iconClassName)}
					href={socials?.website}
				/>
			)}
			{socials?.twitter && (
				<ProfileSocialLink
					icon={TwitterIcon}
					href={socials?.twitter}
					iconClassName={classnames(styles.linkIcon, props.iconClassName)}
				/>
			)}
			{socials?.discord && (
				<ProfileSocialLink
					icon={DiscordIcon}
					href={socials?.discord}
					iconClassName={classnames(styles.linkIcon, props.iconClassName)}
				/>
			)}
		</div>
	)
}

export default CollectionSocials
